import React, { Component } from 'react'
import { Table, Spin } from 'antd'
import PropTypes from 'prop-types'
import _ from 'lodash'
import numeral from 'numeral'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'

import { actions as purchaseOrderActions } from '../../redux/modules/jobFunctions/purchaseOrderActions'

const propTypes = {
  updateSelectedEstimateItems: PropTypes.func.isRequired,
  selectedEstimateItems: PropTypes.object
}

class PurchaseOrderCreationStep1 extends Component {
  state = {
    estimateItems: this.props.selectedEstimateItems
  }

  setColumns = () => {
    return [
      {
        title: 'Name',
        dataIndex: 'name'
      },
      {
        title: 'Description',
        dataIndex: 'description'
      },
      {
        title: 'Quantity',
        dataIndex: 'quantity'
      },
      {
        title: 'Cost',
        dataIndex: 'cost'
      },
      {
        title: 'Total',
        dataIndex: 'total'
      },
      {
        title: 'Overhead',
        dataIndex: 'overhead'
      },
      {
        title: 'Markup',
        dataIndex: 'markup'
      },
      {
        title: 'Grand Total',
        dataIndex: 'grand_total'
      }
    ]
  }

  setDatasource = data => {
    let returnData = []

    _.forEach(data.items, item => {
      const itemTmp = {
        key: item.id,
        name: item.name,
        description: item.description,
        quantity: item.quantity,
        cost: numeral(item.cost).format('$0,0.00'),
        total: numeral(item.total).format('$0,0.00'),
        overhead: `${item.overhead * 100} %`,
        markup: `${item.markup * 100} %`,
        grand_total: numeral(item.grand_total).format('$0,0.00')
      }
      returnData.push(itemTmp)
    })

    return returnData
  }

  render() {
    const estimate = _.get(this.props, 'purchaseOrder.estimate.data')
    const loading = _.get(this.props, 'purchaseOrder.loading')
    const { updateSelectedEstimateItems } = this.props
    const rowSelection = index => {
      const { estimateItems } = this.state
      return {
        onChange: (indexes, selectedObjects) => {
          const newEstimateItems = { ...estimateItems }
          newEstimateItems[index] = selectedObjects
          if (newEstimateItems[index].length === 0) delete newEstimateItems[index]
          this.setState(
            { estimateItems: newEstimateItems },
            updateSelectedEstimateItems(newEstimateItems)
          )
        }
      }
    }

    if (loading) {
      return <Spin spinning={true} />
    } else {
      return (
        <div>
          {estimate.sections.map((section, index) => {
            return (
              <div className="row mt-3" key={index}>
                <div className="col-12">
                  <Table
                    rowSelection={rowSelection(index)}
                    columns={this.setColumns()}
                    dataSource={this.setDatasource(section)}
                    pagination={false}
                    title={() => section.name}
                    style={{ maginBottom: '10px' }}
                  />
                </div>
              </div>
            )
          })}
        </div>
      )
    }
  }
}

PurchaseOrderCreationStep1.propTypes = propTypes

const mapStateToProps = ({ purchaseOrder }, ownProps) => ({
  purchaseOrder
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, purchaseOrderActions), dispatch)
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderCreationStep1))



// WEBPACK FOOTER //
// ./src/components/purchaseorders/PurchaseOrderCreationStep1.js